import { FormLabel, Grid } from "@mui/material";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import React from "react";

export default function CustomizeSwitch({
  Label = "",
  checked,
  onChange,
  onlabel,
  offlabel,
}: {
  Label: string;
  checked: boolean;
  onChange: any;
  onlabel: string;
  offlabel: string;
}) {
  return (
    <div>
      <Grid container>
        <Grid
          item
          xs={4}
          sm={6}
          md={4}
          style={{
            textAlign: "right",
            alignItems: "center",
            display: "flex",
            // minWidth: "3em",
            maxWidth: "fit-content",
            paddingLeft: "20px",
          }}
        >
          <FormLabel style={{ fontSize: ".9rem" }} className="secondColor_200">
            {Label}
          </FormLabel>
        </Grid>
        <Grid
          item
          xs={4}
          sm={6}
          md={4}
          style={{
            maxWidth: "6em",
            minWidth: "3em",
            direction: "initial",
          }}
        >
          <BootstrapSwitchButton
            style="rounded-pill mb-3 CustomizeSwitch"
            checked={checked}
            onlabel={onlabel}
            offlabel={offlabel}
            onChange={onChange}
            onstyle="primary"
            height={25}
          />
        </Grid>
      </Grid>
    </div>
  );
}
